import { StandardEvents } from '@shopify/events';

// Pet's Horizon picker differs from Plant's native select. Fail closed while
// the theme resolves a new selection; never borrow quick-add recommendations.
let generation = 0;
document.addEventListener(StandardEvents.productSelect, async (event) => {
  const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;
  if (!picker || picker.dataset.templateProductMatch !== 'true' || picker.closest('product-card, quick-add-dialog')) return;
  const groups = [...document.querySelectorAll('[data-care-photo-variant]')]
    .filter(group => group.dataset.carePhotoProduct === picker.dataset.productId);
  if (!groups.length) return;
  const current = ++generation;
  groups.forEach(group => { group.hidden = true; });
  try {
    const { detail } = await event.promise;
    if (current !== generation) return;
    const id = detail?.resource?.id == null ? '' : String(detail.resource.id);
    groups.forEach(group => { group.hidden = !id || group.dataset.carePhotoVariant !== id; });
  } catch {
    // Keep the product-specific photograph hidden after unresolved selection.
  }
});
